const initialState = {
  mobile_filter_panel_open: false,
  mobile_booking_enquiry_form_show: false,
  visitedStoryOrListing: false,
}

export default (state = initialState, action) => {
  switch (action.type) {
    case 'SET_LISTINGS_MOBILE_FILTER_VIEW_STATE':
      return {
        ...state,
        mobile_filter_panel_open: action.payload,
      }

    case 'SET_LISTING_MOBILE_BOOKING_ENQUIRY_FORM_VIEW_STATE':
      return {
        ...state,
        mobile_booking_enquiry_form_show: action.payload,
      }

    default:
      return state
  }
}
